import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
    FaMapMarkerAlt,
    FaHome,
    FaBuilding,
    FaPlus,
    FaEdit,
    FaTrash,
} from "react-icons/fa";

import API from "../../../../services/api";

import "./CustomerSavedAddresses.css";

function CustomerSavedAddresses() {

    const navigate = useNavigate();

    const [addresses, setAddresses] = useState([]);

    const [loading, setLoading] = useState(true);

    const fetchAddresses = async () => {

        try{

            const res = await API.get("/address");

            if(res.data.success){

                setAddresses(res.data.addresses);

            }

        }

        catch(error){

            console.log(error);

        }

        finally{

            setLoading(false);

        }

    };

    useEffect(()=>{

        fetchAddresses();

    },[]);

    const deleteAddress = async(id)=>{

        if(!window.confirm("Delete this address?")) return;

        try{

            await API.delete(`/address/${id}`);

            fetchAddresses();

        }

        catch(error){

            console.log(error);

        }

    };

    return(

        <div className="saved-address-page">

            <div className="saved-header">

                <FaMapMarkerAlt />

                <div>

                    <h2>Saved Addresses</h2>

                    <p>Manage your delivery locations.</p>

                </div>

            </div>

            <button

                className="add-address-btn"

                onClick={()=>navigate("/address")}

            >

                <FaPlus />

                Add New Address

            </button>

            {

                loading ?

                <p>Loading...</p>

                :

                addresses.length===0 ?

                <div className="empty-address">

                    No saved addresses.

                </div>

                :

                addresses.map((address)=>(

                    <div

                        key={address._id}

                        className="address-card"

                    >

                        <div className="address-left">

                            {

                                address.type==="Home"

                                ?

                                <FaHome/>

                                :

                                <FaBuilding/>

                            }

                            <div>

                                <h4>

                                    {address.type}

                                </h4>

                                <p>

                                    {address.houseNo},

                                    {" "}

                                    {address.street},

                                    {" "}

                                    {address.city},

                                    {" "}

                                    {address.state}

                                </p>

                            </div>

                        </div>

                        <div className="address-actions">

                            <button>

                                <FaEdit/>

                            </button>

                            <button

                                onClick={()=>deleteAddress(address._id)}

                            >

                                <FaTrash/>

                            </button>

                        </div>

                    </div>

                ))

            }

        </div>

    );

}

export default CustomerSavedAddresses;